import {Path} from "react-hook-form";
import {css, cx} from "@panda/css";

import {CheckboxControlled} from "@pg-design/rhf-components-module";

import {validationMessages} from "../../form/utils/validation_messages";
import type {IConsentTemplate} from "../types";
import {ConsentCheckboxLabel} from "./ConsentCheckboxLabel";

interface IProps {
    template: IConsentTemplate;
    className?: string;
}

export function ConsentCheckboxField<FormValues extends Record<"consents", Record<string, boolean>>>({template, className}: IProps) {
    return (
        <div className={cx(consentField, className)}>
            <CheckboxControlled<FormValues>
                name={`consents.${template.ulid}` as Path<FormValues>}
                labelContent={<ConsentCheckboxLabel template={template} />}
                rules={template.consent_mode === "required" ? {required: validationMessages.required} : undefined}
            />
        </div>
    );
}

const consentField = css({
    width: "100%",

    "& > div": {
        display: "flex",
        alignItems: "flex-start",
        width: "100%"
    },

    "& label": {
        display: "block",
        flex: 1,
        alignItems: "flex-start",
        height: "auto"
    }
});
import {Path} from "react-hook-form";
import {css, cx} from "@panda/css";

import {CheckboxControlled} from "@pg-design/rhf-components-module";

import {validationMessages} from "../../form/utils/validation_messages";
import type {IConsentTemplate} from "../types";
import {ConsentCheckboxLabel} from "./ConsentCheckboxLabel";

interface IProps {
    template: IConsentTemplate;
    className?: string;
}

export function ConsentCheckboxField<FormValues extends Record<"consents", Record<string, boolean>>>({template, className}: IProps) {
    return (
        <div className={cx(consentField, className)}>
            <CheckboxControlled<FormValues>
                name={`consents.${template.ulid}` as Path<FormValues>}
                labelContent={<ConsentCheckboxLabel template={template} />}
                rules={template.consent_mode === "required" ? {required: validationMessages.required} : undefined}
            />
        </div>
    );
}

const consentField = css({
    width: "100%",

    "& > div": {
        display: "flex",
        alignItems: "flex-start",
        width: "100%"
    },

    "& label": {
        display: "block",
        flex: 1,
        alignItems: "flex-start",
        height: "auto"
    }
});
